import React, { createContext, useReducer } from 'react';
import { CartReducer, sumItems } from './CartReducer';
import { Notification } from 'element-react';

export const CartContext = createContext()

const storage = localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')) : [];
const initialState = { cartItems: storage, ...sumItems(storage), checkout: false, orderid:0, };

const CartContextProvider = ({children}) => {

    const [state, dispatch] = useReducer(CartReducer, initialState)

    const increase = payload => {
        const itemInCart = state.cartItems.find(item => item.id === payload.id);
        const maxStock = payload.stockQuantity !== undefined && payload.stockQuantity !== null ? payload.stockQuantity : 50;
        if (itemInCart && itemInCart.quantity >= maxStock) {
            Notification({
                title: 'Limit Reached',
                message: `Cannot add more. Only ${maxStock} available in stock!`,
                type: 'warning'
            });
            return;
        }
        dispatch({type: 'INCREASE', payload})
    }

    const decrease = payload => {
        dispatch({type: 'DECREASE', payload})
    }

    const addProduct = payload => {
        const maxStock = payload.stockQuantity !== undefined && payload.stockQuantity !== null ? payload.stockQuantity : 50;
        if (maxStock <= 0) {
            Notification({
                title: 'Out of Stock',
                message: 'This item is currently out of stock.',
                type: 'error'
            });
            return;
        }
        dispatch({type: 'ADD_ITEM', payload})
    }

    const removeProduct = payload => {
        dispatch({type: 'REMOVE_ITEM', payload})
    }

    const clearCart = () => {
        dispatch({type: 'CLEAR'})
    }

    const handleCheckout = () => {
        console.log('CHECKOUT', state);
        dispatch({type: 'CHECKOUT'})
    }

    const clearCheckout = () => {
        console.log('CLEARCHECKOUT', state);
        dispatch({type: 'CLEARCHECKOUT'})
    }

    const addorderidCheckout = (payload) => {
        console.log('addorderidCheckout ', state);
        dispatch({type: 'ADDORDERIDCHECKOUT'})
    }

    const contextValues = {
        removeProduct,
        addProduct,
        increase,
        decrease,
        clearCart,
        handleCheckout,
        clearCheckout,
        addorderidCheckout,
        ...state
    } 

    return ( 
        <CartContext.Provider value={contextValues} >
            { children }
        </CartContext.Provider>
     );
}
 
export default CartContextProvider;